/**
 * Trademark Trading Product Data
 *
 * @deprecated - This file uses the legacy structure with hybrid merge approach.
 * MIGRATION PENDING: Will be migrated to JSON translations structure.
 * See: public/locales/en/products/tadreamk-eye.json for the new pattern.
 *
 * For now, this product continues to work using the old translation pattern.
 */

import trademarkTradingImage from "../../assets/images/products/Trademark transaction.webp";

import { FEATURE_ICONS, BUSINESS_CONTEXT_ICONS } from "../../configs/emojis";
import { APP_CONFIG } from "../../configs/config";

const trademarkTradingData = {
  id: 5,
  image: trademarkTradingImage,
  title: "Trademark Trading",
  abstract:
    "A non-profit community platform for logo competitions. Share open calls, invite creative submissions, and help mission-driven teams find visual identities through transparent participation.",
  ctaUrl: APP_CONFIG.TRADEMARK_TRADING_URL,
  ctaText: "Explore Competitions",
  category: "Community Tools",
  primaryFeatureTag: "Non-profit Logo Competition",
  imageAlt: "Logo Competition Platform community showcase",
  ctaPlacement: "top",
  showOverviewHeading: false,
  description: [
    {
      icon: "🏪",
      title: "Open community briefs",
      text: "Each competition brief explains the organization, purpose, design goals, timeline, and participation guidelines so contributors understand the public benefit behind the work.",
    },
    {
      icon: BUSINESS_CONTEXT_ICONS.PROFESSIONAL_SERVICE,
      title: "Transparent submissions",
      text: "Creators can submit logo ideas, revisions, and supporting notes in a shared space designed for fair review. Questions, updates, and milestones stay visible so the community can follow progress without sales pressure.",
    },
    {
      icon: FEATURE_ICONS.BAR_CHART,
      title: "Mission-first review",
      text: "Review tools help organizers compare submissions against the stated brief, accessibility needs, originality, and community fit. The emphasis stays on thoughtful contribution, inclusive participation, and respectful feedback.",
    },
    {
      icon: BUSINESS_CONTEXT_ICONS.STRATEGIC_PLANNING,
      title: "Creator recognition",
      text: "Participant profiles and project histories make it easy to credit contributors, acknowledge finalists, and celebrate selected work. Organizers can keep a transparent record of decisions and community appreciation.",
    },
    {
      icon: FEATURE_ICONS.SHIELD,
      title: "Responsible stewardship",
      text: "Simple handoff checklists and archive tools help teams preserve selected designs, usage notes, and contributor acknowledgements. The platform supports clear records while keeping the program community-centered.",
    },
  ],
};

export default trademarkTradingData;
